import clsx from 'clsx';
import { NavItem } from '..';
import { Avatar, Clock } from '../../../components';
import { useAppContext, useLocalize } from '../../../hooks';
import type { MenuItem } from '../MainLayout';

type MobileMenuProps = {
  avatarUrl?: string;
  userName?: string;
  links: MenuItem[];
};

const MenuBlock: React.FC<React.PropsWithChildren<{ first?: boolean }>> = ({
  first,
  children,
}) => {
  return (
    <>
      <div
        className={clsx(
          'border-t border-t-solid border-t-[#4D4D57] w-full',
          first ? 'mb-lg' : 'my-lg'
        )}
      ></div>
      <div className="w-full px-lg flex flex-col items-center justify-center">
        {children}
      </div>
    </>
  );
};

export const MobileMenu: React.FC<MobileMenuProps> = ({
  links,
  avatarUrl,
  userName,
}) => {
  const { t } = useLocalize();
  const { menuOpened, toggleMenu } = useAppContext();

  return (
    !!menuOpened && (
      <div
        style={{ height: 'calc(100dvh - 6.4rem + 0.1rem)' }}
        className={clsx(
          'transition-all duration-300 ease-out transform animate-slideIn',
          'fixed top-[6.4rem] w-full left-0 bg-activeHeader flex flex-col items-center justify-between px-md pb-lg'
        )}
      >
        <MenuBlock first>
          <Avatar
            userName={userName}
            avatarUrl={avatarUrl}
            className="w-[8rem] h-[8rem]"
          />
          <div className="font-semibold text-big mt-sm">{userName}</div>
        </MenuBlock>
        <MenuBlock>
          <nav>
            {links
              .filter(l => l.text)
              .map(link => {
                return (
                  <NavItem
                    onClick={toggleMenu}
                    key={link.text || link.url}
                    menuItem={link}
                    activeClassName="text-activeHeaderText"
                    linkClassName={
                      'hover:text-main transition px-md font-semibold text-section'
                    }
                  />
                );
              })}
          </nav>
        </MenuBlock>
        <MenuBlock>
          <Clock
            label={t('menu.hoursleft')}
            formatType="h[h] mm[m]"
            time={new Date(Date.now() + 50 * 600000)}
            labelClassName="text-small"
            timeClassName="text-white font-semibold text-section"
            className="text-accordionBorder px-md font-semibold flex-col gap-y-sm mb-xl"
          />
        </MenuBlock>
      </div>
    )
  );
};
